import Vue from 'vue'
import _ from 'lodash'

import {
  // GET_OCCUPATION_LIST
  GET_OCCUPATION_LIST_REQUEST,
  GET_OCCUPATION_LIST_SUCCESS,
  GET_OCCUPATION_LIST_FAILURE,
} from '@/lib/mutationTypes'
import API, { HOMEPAGE_URL } from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const state = {
  occupationList: [],
  isLoading: false,
  isError: false,
}

const mutations = {
  [GET_OCCUPATION_LIST_REQUEST]: state => {
    state.isLoading = true
    state.isError = false
  },
  [GET_OCCUPATION_LIST_SUCCESS]: (state, payload) => {
    state.occupationList = [...payload]
    state.isLoading = false
    state.isError = false
  },
  [GET_OCCUPATION_LIST_FAILURE]: state => {
    state.isLoading = false
    state.isError = true
  },
}

const actions = {
  getOccupationInformation: ({ commit }) => {
    commit(GET_OCCUPATION_LIST_REQUEST)

    const headers = generateAuthorizationRequestHeader()

    Vue.http
      .get(API.GENERAL.OCCUPATION, {
        headers,
      })
      .then(res => res.json())
      .then(
        response => commit(GET_OCCUPATION_LIST_SUCCESS, response.result.occupation),
        error => {
          const { status } = error

          if (status === 401) {
            window.location.href = HOMEPAGE_URL
          }

          if (status === 403) {
            this._vm.$swal({
              type: 'error',
              title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
            })
          }

          if (status === 400) {
            commit(GET_OCCUPATION_LIST_FAILURE)
          }

          if (status === 500) {
            commit(GET_OCCUPATION_LIST_FAILURE)
          }
        },
      )
  },
}

const getters = {
  occupationList: state => state.occupationList,
  isLoadingOccupation: state => state.isLoading,
  isErrorOccupation: state => state.isError,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
